import React, {
    ReactElement, useState,
} from "react";
import { AiOutlinePlus } from "react-icons/ai";
import {
    useGetTemplateFieldsQuery,
} from "../../../../__generated__/api";
import { Loading } from "../../../../components";
import { Filters } from "../../../../components/filters/Filters";
import useRouting, { Link } from "../../../../contexts/Routing";
import { ErrorRemote } from "../../../error/Error";

export default function FieldTemplates(): ReactElement {
    const { data, error, loading: isLoading } = useGetTemplateFieldsQuery({
        fetchPolicy: "no-cache",
    });
    const { Paths } = useRouting();

    const [formSearch, setFormSearch] = useState<string>("");

    if (isLoading) {
        return <Loading />;
    }
    if (error || !data) {
        return <ErrorRemote error={error} />;
    }

    let { formFields } = data;

    if (formSearch) {
        const search = formSearch.toLocaleLowerCase();
        formFields = formFields?.filter(row => row.name.toLocaleLowerCase().includes(search)
            || row.description?.toLocaleLowerCase().includes(search));
    }

    return (
        <div className="d-flex align-items-stretch">

            <div className="border p-3 rounded  bg-white col ms-2">
                {formFields?.isNotEmpty ? (
                    <>
                        <div className="d-flex justify-content-between align-items-center mb-3">
                            <h5 className="text-light mb-0">
                                Form Fields
                            </h5>
                            <Link
                                to={Paths.ADMINISTRATOR_SETTING_ID}
                                params={{
                                    id: "template",
                                    setting: "request-forms",
                                }}
                                className="btn btn-none btn-sm"
                            >
                                <AiOutlinePlus />
                                {" "}
                                Template
                            </Link>
                        </div>
                        <Filters
                            search={formSearch}
                            onSetSearch={setFormSearch}
                        />
                        {formFields.isNotEmpty ? (

                            <div className="list-group">
                                {formFields?.map(field => (
                                    <Link
                                        to={Paths.ADMINISTRATOR_SETTING_ID}
                                        key={field.id}
                                        params={{
                                            id: field.id,
                                            setting: "request-fields",
                                        }}
                                        className="list-group-item list-group-item-action
                                            d-flex align-items- justify-content-between"
                                    >

                                        <div className="d-flex flex-column flex-grow-1">
                                            <div className="d-flex w-100 align-items-end mb-2">
                                                <h5 className="mb-0">
                                                    {field.name}
                                                    {" "}
                                                </h5>

                                                <small className="ms-3 text-light " />
                                            </div>
                                            <small>{field.description}</small>
                                        </div>

                                    </Link>
                                ))}
                            </div>
                        ) : (
                            <div className="text-center text-light">No request types found matching your filters.</div>
                        )}
                        <div className="d-flex justify-content-end align-items-center mt-3">

                            <Link
                                to={Paths.ADMINISTRATOR_SETTING_ID}
                                params={{
                                    id: "template",
                                    setting: "request-fields",
                                }}
                                className="btn btn-secondary btn-sm"
                            >
                                <AiOutlinePlus />
                                {" "}
                                Custom Field
                            </Link>
                        </div>

                    </>
                ) : (
                    <div className="d-flex flex-column align-items-center justify-content-center h-100 text-light my-4">
                        <h5 className="text-light">
                            Template
                        </h5>
                        <Link
                            to={Paths.ADMINISTRATOR_SETTING_ID}
                            params={{
                                id: "template",
                                setting: "request-fields",
                            }}
                            className="btn btn-secondary btn-sm my-3"
                        >
                            <AiOutlinePlus />
                            {" "}
                            Add Field
                        </Link>
                        <small>
                            Create a new custom fields
                        </small>
                    </div>

                )}

            </div>

        </div>
    );
}
